var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isFormHidden
        ? _c(
            "form",
            {
              staticClass: "subscribe-form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.sendForm($event)
                }
              }
            },
            [
              !_vm.edit
                ? _c("div", { staticClass: "subscribe-form__container" }, [
                    _c(
                      "label",
                      {
                        staticClass: "subscribe-form__label",
                        attrs: { for: "subscribe-email" }
                      },
                      [_vm._v(_vm._s(_vm.text.labelEmail[_vm.lang]))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.params.email,
                          expression: "params.email"
                        }
                      ],
                      staticClass: "subscribe-form__field",
                      attrs: { id: "subscribe-email", type: "text" },
                      domProps: { value: _vm.params.email },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.params, "email", $event.target.value)
                          },
                          _vm.checkEmail
                        ],
                        blur: _vm.checkEmail,
                        focus: _vm.clearEmailError
                      }
                    }),
                    _vm._v(" "),
                    _vm.error.email
                      ? _c("span", { staticClass: "subscribe-form__error" }, [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(_vm.error.email) }
                          })
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subscribe-form__container" },
                [
                  _vm._l(_vm.rubrics, function(item) {
                    return _c(
                      "label",
                      { key: item.id, staticClass: "subscribe-form__checkbox" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.params.rubrics,
                              expression: "params.rubrics"
                            }
                          ],
                          staticClass: "subscribe-form__checkbox-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: Number(item.id),
                            checked: Array.isArray(_vm.params.rubrics)
                              ? _vm._i(_vm.params.rubrics, Number(item.id)) > -1
                              : _vm.params.rubrics
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.params.rubrics,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = Number(item.id),
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.params,
                                      "rubrics",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.params,
                                      "rubrics",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.params, "rubrics", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "subscribe-form__checkbox-box"
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "subscribe-form__checkbox-info" },
                          [
                            _c("span", {
                              staticClass: "subscribe-form__checkbox-title",
                              domProps: { innerHTML: _vm._s(item.name) }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "subscribe-form__checkbox-text",
                              domProps: { innerHTML: _vm._s(item.description) }
                            })
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "subscribe-form__error" })
                ],
                2
              ),
              _vm._v(" "),
              !_vm.edit
                ? _c("div", { staticClass: "subscribe-form__container" }, [
                    _c("label", { staticClass: "subscribe-form__checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.params.agreement,
                            expression: "params.agreement"
                          }
                        ],
                        staticClass: "subscribe-form__checkbox-input",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.params.agreement)
                            ? _vm._i(_vm.params.agreement, null) > -1
                            : _vm.params.agreement
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.params.agreement,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.params,
                                    "agreement",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.params,
                                    "agreement",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.params, "agreement", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "subscribe-form__checkbox-box"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "subscribe-form__checkbox-info" },
                        [
                          _c("p", {
                            staticClass: "subscribe-form__checkbox-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.text.agreement[_vm.lang])
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "subscribe-form__error" })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: [
                    "subscribe-form__btn btn",
                    { "subscribe-form__btn--disabled": !_vm.isSubmitAvalible }
                  ],
                  attrs: { type: "submit", disabled: !_vm.isSubmitAvalible }
                },
                [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.text.submitBtn[_vm.lang])
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSendSuccess
        ? [
            _c(
              "p",
              {
                class: [
                  "subscribe-form-msg",
                  { "subscribe-form-msg--green": _vm.edit }
                ]
              },
              [_c("span", { domProps: { innerHTML: _vm._s(_vm.successMsg) } })]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "subscribe-social" }, [
        _c("p", {
          domProps: { innerHTML: _vm._s(_vm.text.socialLinksText[_vm.lang]) }
        }),
        _vm._v(" "),
        _vm._m(0)
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "subscribe-social__list" }, [
      _c("li", { staticClass: "subscribe-social__item" }, [
        _c(
          "a",
          {
            staticClass: "subscribe-social__link",
            attrs: {
              href: "https://www.facebook.com/gazprom.neft",
              target: "_blank"
            }
          },
          [
            _c("span", {
              staticClass: "subscribe-social__icon subscribe-social__icon--fb"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "subscribe-social__text" }, [
              _vm._v("Facebook")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "subscribe-social__item" }, [
        _c(
          "a",
          {
            staticClass: "subscribe-social__link",
            attrs: { href: "https://vk.com/gazprom_neft", target: "_blank" }
          },
          [
            _c("span", {
              staticClass: "subscribe-social__icon subscribe-social__icon--vk"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "subscribe-social__text" }, [
              _vm._v("Вконтакте")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "subscribe-social__item" }, [
        _c(
          "a",
          {
            staticClass: "subscribe-social__link",
            attrs: {
              href: "https://www.youtube.com/user/GAZPROMNEFT",
              target: "_blank"
            }
          },
          [
            _c("span", {
              staticClass:
                "subscribe-social__icon subscribe-social__icon--youtube"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "subscribe-social__text" }, [
              _vm._v("Youtube")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "subscribe-social__item" }, [
        _c(
          "a",
          {
            staticClass: "subscribe-social__link",
            attrs: {
              href: "https://www.instagram.com/gazprom_neft.ru/",
              target: "_blank"
            }
          },
          [
            _c("span", {
              staticClass: "subscribe-social__icon subscribe-social__icon--inst"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "subscribe-social__text" }, [
              _vm._v("Instagram")
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5754bd6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5754bd6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/components/subscribtion/subscribtion.vue
// module id = 119
// module chunks = 0